export default __webpack_public_path__ + "static/media/hit2.918b6925.wav";